import script from "./taskrkfollowup.vue?vue&type=script&lang=ts&setup=true"
export * from "./taskrkfollowup.vue?vue&type=script&lang=ts&setup=true"

import "./taskrkfollowup.vue?vue&type=style&index=0&id=7c465346&lang=scss"

const __exports__ = script;

export default __exports__